import { useEffect } from 'react';
import { useFlow } from '../hooks/useFlow';
import Layout from './Layout';
import { useErrorText } from '../hooks/useErrorText';
import { ERROR_TEXT } from '../const/errorText';
import { ClinicProps } from '../types/Props';

const PAGE_TRANSITION_DELAY_MS = 3000;

function ReceptionError({ clinicName }: ClinicProps) {
  const { setFlow } = useFlow();
  const { errorText } = useErrorText();

  useEffect(() => {
    setTimeout(() => {
      setFlow('top');
    }, PAGE_TRANSITION_DELAY_MS);
  }, []);

  return (
    <Layout flowName="受付エラー" clinicName={clinicName || undefined}>
      <div className="grid place-items-center mt-8 text-2xl font-bold text-gray-500">
        <p className="mt-14 text-center whitespace-pre-wrap">{errorText ?? ERROR_TEXT.receptionFailure}</p>
      </div>
    </Layout>
  );
}

export default ReceptionError;
